module.exports = __webpack_public_path__ + "img/catalog-jian.0a74f917.svg";